import { Component, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { NavbarComponent, ToastMessagesComponent } from "@core/components";
import { InitService } from "@core/services";
import { SaveModalComponent } from "@shared/components";
import { GlobalService } from "@shared/services";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [ToastMessagesComponent, RouterOutlet, NavbarComponent, SaveModalComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit {
  initService = inject(InitService);
  globalService = inject(GlobalService);

  constructor() {
    window.addEventListener("online", () => {
      this.globalService.offline.set(false);
    });

    window.addEventListener("offline", () => {
      this.globalService.offline.set(true);
    });
  }

  ngOnInit() {
    this.initService.init();
    this.globalService.init();
  }
}
